const GROUP_MAIN = 'main';
const GROUP_TECHNICAL = 'technical';
const GROUP_API = 'api';

export {
  GROUP_MAIN,
  GROUP_TECHNICAL,
  GROUP_API,
};
